import React, { useMemo, useState } from 'react'
import { Row, Col, Image, Form, Button, Alert, ProgressBar } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Card from '../../../components/Card'

// img
import auth5 from '../../../assets/images/auth/05.png'
import UserService from '../../../services/user/UserService'
import SweetAlert from 'react-bootstrap-sweetalert'

const SignUp = () => {
   let history = useNavigate()
   const [currentPassword, setCurrentPassword] = useState("");
   const [newPassword, setNewPassword] = useState("");
   const [confirmPassword, setConfirmPassword] = useState("");
   const [message, setMessage] = useState("");
   const [variant, setVariant] = useState("success");
   const [showUpdateSuccess, setShowUpdateSuccess] = useState(false)
   const [showUpdateFailed, setShowUpdateFailed] = useState(false)
   const [showPassword, setShowPassword] = useState(false)
   const [passwordRules, setPasswordRules] = useState({
      length: false,
      upper: false,
      lower: false,
      number: false,
      symbol: false,
      })



   const userService = useMemo(() => new UserService(), [])


      const evaluatePassword = (password) => {
      const rules = {
         length: password.length >= 8,
         upper: /[A-Z]/.test(password),
         lower: /[a-z]/.test(password),
         number: /[0-9]/.test(password),
         symbol: /[^A-Za-z0-9]/.test(password),
      }

      setPasswordRules(rules)
      }

      const ChecklistValidasi = ({ rules }) => {
      return (
         <ul className="list-unstyled mt-2 mb-1">
            <li className={rules.length ? "text-success" : "text-danger"}>
            {rules.length ? "✔" : "✖"} Minimal 8 karakter
            </li>
            <li className={rules.upper ? "text-success" : "text-danger"}>
            {rules.upper ? "✔" : "✖"} Huruf kapital
            </li>
            <li className={rules.lower ? "text-success" : "text-danger"}>
            {rules.lower ? "✔" : "✖"} Huruf kecil
            </li>
            <li className={rules.number ? "text-success" : "text-danger"}>
            {rules.number ? "✔" : "✖"} Angka
            </li>
            <li className={rules.symbol ? "text-success" : "text-danger"}>
            {rules.symbol ? "✔" : "✖"} Simbol
            </li>
         </ul>
      )
      }


      const getPasswordStrength = () => {
      const passed = Object.values(passwordRules).filter(Boolean).length
      return (passed / 5) * 100
      }




   const handleSubmit = (e) => {
      e.preventDefault();
      if (newPassword !== confirmPassword) {
         setMessage("New password and confirm password do not match!");
         setVariant("danger");
         return;
      }
      
      if (getPasswordStrength() < 100) {
         setMessage("Password belum memenuhi seluruh kriteria keamanan");
         setVariant("danger");
         return;
      }
     

      let jsonData = {
         "username": localStorage.getItem("username"),
         "oldPassword": currentPassword,
         "newPassword": newPassword
      }
      userService.updatePass(jsonData).then((response) => {
         console.log(response)
         setMessage(response.data);
         setVariant("success");
         setShowUpdateSuccess(true)
      }).catch((error) => {
         setMessage("Error updating password: " + error.response.data.message);
         setVariant("danger");
         setShowUpdateFailed(true)
      })

   };

   const handleClickUpdateSuccess = () => {
      setShowUpdateSuccess(false)
      history('/dashboard')
   }

   const handleClickUpdateFailed = () => {
      setShowUpdateFailed(false)
   }


   return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <div className="col-md-6 d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Image src={auth5} className="Image-fluid gradient-main animated-scaleX" alt="images" />
               </div>
               <Col md="6">
                  <Row className="justify-content-center">
                     <Col md="10">
                        <Card className="card-transparent auth-card shadow-none d-flex justify-content-center mb-0">
                           <Card.Body>
                              <div className="container mt-5">
                                 <h3>Update Password</h3>
                                 {message && <Alert variant={variant}>{message}</Alert>}
                                 <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="formCurrentPassword" className='mt-3'>
                                       <Form.Label>Current Password</Form.Label>
                                       <Form.Control
                                          type="password"
                                          placeholder="Enter current password"
                                          value={currentPassword}
                                          onChange={(e) => setCurrentPassword(e.target.value)}
                                       />
                                    </Form.Group>

                                    <Form.Group controlId="formNewPassword" className="mt-3">
                                        
                                    <Form.Label>New Password</Form.Label>

                                    <div className="d-flex">
                                       <Form.Control
                                          type={showPassword ? "text" : "password"}
                                          value={newPassword}
                                          placeholder="Enter new password"
                                          onChange={(e) => {
                                          const value = e.target.value
                                          setNewPassword(value)
                                          evaluatePassword(value)
                                          }}
                                          isInvalid={getPasswordStrength() < 100}
                                          required
                                       />

                                       <Button
                                          variant="outline-secondary"
                                          type="button"
                                          className="ms-2"
                                          onClick={() => setShowPassword(!showPassword)}
                                       >
                                          {showPassword ? "🙈" : "👁"}
                                       </Button>
                                    </div>
                                    </Form.Group>
                                    
                                    {newPassword && <ChecklistValidasi rules={passwordRules} />}

                                       {newPassword && (
                                       <ProgressBar
                                          now={getPasswordStrength()}
                                          className="mb-3"
                                          variant={
                                             getPasswordStrength() === 100
                                             ? "success"
                                             : getPasswordStrength() >= 60
                                             ? "warning"
                                             : "danger"
                                          }
                                          label={
                                             getPasswordStrength() === 100
                                             ? "Strong"
                                             : getPasswordStrength() >= 60
                                             ? "Medium"
                                             : "Weak"
                                          }
                                       />
                                       )}



                                    <Form.Group controlId="formConfirmPassword" className="mt-3">
                                       <Form.Label>Confirm New Password</Form.Label>
                                       <Form.Control
                                          type="password"
                                          placeholder="Confirm new password"
                                          value={confirmPassword}
                                          isInvalid={confirmPassword && confirmPassword !== newPassword}
                                          onChange={(e) => setConfirmPassword(e.target.value)}
                                          required
                                       />
                                       <Form.Control.Feedback type="invalid">
                                          Password tidak sama
                                       </Form.Control.Feedback>
                                       </Form.Group>

                                    <Button variant="primary" type="submit" className='mt-3'>
                                       Update Password
                                    </Button>
                                 </Form>
                              </div>

                              

                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
                  <div className="sign-bg sign-bg-right">
                     <svg width="280" height="230" viewBox="0 0 421 359" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.05">
                           <rect x="-15.0845" y="154.773" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 -15.0845 154.773)" fill="#3A57E8" />
                           <rect x="149.47" y="319.328" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 149.47 319.328)" fill="#3A57E8" />
                           <rect x="203.936" y="99.543" width="310.286" height="77.5714" rx="38.7857" transform="rotate(45 203.936 99.543)" fill="#3A57E8" />
                           <rect x="204.316" y="-229.172" width="543" height="77.5714" rx="38.7857" transform="rotate(45 204.316 -229.172)" fill="#3A57E8" />
                        </g>
                     </svg>
                  </div>
               </Col>
            </Row>
         </section>
         {
            showUpdateSuccess &&
            <SweetAlert
               title="Success"
               success
               onConfirm={handleClickUpdateSuccess}
               btnSize="sm"
               timeout={5000}
            >
               {message}
            </SweetAlert>
         }
         {
            showUpdateFailed &&
            <SweetAlert
               title="Gagal"
               danger
               onConfirm={handleClickUpdateFailed}
               btnSize="sm"
            >
               {message}
            </SweetAlert>
         }
      </>
   )
}

export default SignUp
